import React, { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CustomAccordion from "components/CustomAccordion";

const TreasureHuntSection: FC = () => {
  return (
    <>
      <Typography component="h2" variant="h2" my={4}>
        Treasure Hunt
      </Typography>
      <CustomAccordion title="What is a Treasure Hunt?">
        <Box width="100%">
          <Typography>
            Uniqly's Treasure Hunt is an interactive phygital experience powered
            by a web-based app. It's designed to engage participants in the real
            world through a combination of digital tasks and physical
            exploration — often used at festivals, conferences, or branded
            events.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="How does the Treasure Hunt work?">
        <Box width="100%">
          <Typography mb={2}>
            Participants log in to the web app using their email. The app
            presents them with tasks to complete — such as scanning NFC tags
            hidden across the event space or interacting with physical elements.
            Each completed task brings them closer to earning a reward.
          </Typography>
          <Typography>
            Once all required actions are completed, participants either
            automatically receive a reward (such as an NFT, merch, or token), or
            are entered into a prize draw, depending on the event format.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="What does Uniqly offer for Treasure Hunts?">
        <Box width="100%">
          <Typography mb={2}>
            Uniqly provides a complete system for organizing and managing
            Treasure Hunt experiences, including:
          </Typography>
          <Typography component="div" mb={2}>
            <ul>
              <li>
                A white-label or co-branded web app accessible via browser
              </li>
              <li>NFC-tagged objects placed around the event location</li>
              <li>Configurable task logic and progression tracking</li>
              <li>Instant NFT minting and wallet assignment</li>
              <li>Prize distribution (automatic or randomized)</li>
              <li>Real-time dashboard and analytics for organizers</li>
              <li>Custom branding, gamification, and phygital utility</li>
            </ul>
          </Typography>
          <Typography>
            This is a unique way to onboard new users, drive physical
            interaction, and build lasting engagement between communities and
            brands.
          </Typography>
        </Box>
      </CustomAccordion>
    </>
  );
};

export default TreasureHuntSection;
